import { TaskStatus } from 'commons/types/enums'

const map: { [key: string]: string } = {
  [TaskStatus.NEW]: 'New',
  [TaskStatus.COMPLETE]: 'Complete'
}

export const getTaskStatusLabel = (name: string) => map[name] || name
